<script setup lang="ts">
import { PV } from "@/widgets";
import { RouterLink } from "vue-router";

const props = defineProps<{
    to: string;
    icon: string;
    label: string;
}>();
</script>

<template>
    <RouterLink :to="props.to">
        <PV.Button :icon="props.icon" :label="props.label" severity="contrast" size="small" text />
    </RouterLink>
</template>
